export default "__VITE_ASSET__CHiA5jqW__"